import { createFileRoute } from '@tanstack/react-router'

import { paginaObrigatoria } from '@/lib/visoes'

import { PaginaComAbas } from '@/components/heimdall/pagina-com-abas'

import { AbaAbrirMrs } from '@/features/entregas-merge/aba'
import { AbaMilestones } from '@/features/entregas-milestones/aba'

export const Route = createFileRoute('/$perfil/entregas')({
  component: Tela,
})

/** Entregas: andamento das milestones e abertura de MRs. Cada aba vem da pasta da sua peça. */
function Tela() {
  return (
    <PaginaComAbas
      pagina={paginaObrigatoria('entregas')}
      abas={[
        { id: 'milestones', titulo: 'Milestones', conteudo: <AbaMilestones /> },
        { id: 'mrs', titulo: 'Abrir MRs', conteudo: <AbaAbrirMrs /> },
      ]}
    />
  )
}
